import { FeatureFlags } from '@/constants/features'
import type { FeatureConfig } from '@/components/FeatureConfigProvider/types'

export const commonFeatureConfig: FeatureConfig = {
  showAllFeatures: true,
  featureFlags: {
    [FeatureFlags.vesselCard.riskInfo]: false,
    [FeatureFlags.vesselCard.sanctions]: false,
    [FeatureFlags.vesselCard.violation]: false,
    [FeatureFlags.vesselSearch.advanced]: false,
    [FeatureFlags.mapLayer.weather]: false,
    [FeatureFlags.vesselCard.management.shipyardAnalysis]: false,
    [FeatureFlags.vesselCard.management.companyAiSummary]: false,
    [FeatureFlags.vesselCard.management.companyRiskTab]: false,
    [FeatureFlags.mapControl.miniMap]: true,
    [FeatureFlags.mapControl.polylineMeasure]: true,
  },
  modules: {
    vesselCard: {
      riskInfo: false,
      sanctions: false,
      violation: false,
    },
  },
}

export function createFeatureConfig(overrides: Partial<FeatureConfig> = {}): FeatureConfig {
  const overrideModules = overrides.modules ?? {}

  return {
    ...commonFeatureConfig,
    ...overrides,
    featureFlags: {
      ...commonFeatureConfig.featureFlags,
      ...overrides.featureFlags,
    },
    modules: {
      ...commonFeatureConfig.modules,
      ...overrideModules,
      ...Object.fromEntries(
        Object.entries(overrideModules).map(([key, value]) => [
          key,
          {
            ...commonFeatureConfig.modules?.[key],
            ...value,
          },
        ])
      ),
    },
  }
}
